export const LOCAL_STORAGE_KEY = 'first-point';
export const SESSION_STORAGE_KEY = 'session-point';

export const phone = '+971 58 285 0719';
export const email = 'm.taha@andersenlab.com';

export const meetupDate = '2024-12-09';
export const meetupTime = '13:00 (GMT+4)';
